import { classConstants } from '../constants';

const initialState = {
    loading: false,
    classes: [],
    error: null,
    creatingClass: false,
    createError: null,
    updatingClass: false,
    updateError: null,
};

const classReducer = (state = initialState, action) => {
    switch (action.type) {
        case classConstants.FETCH_CLASSES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case classConstants.FETCH_CLASSES_SUCCESS:
            return {
                ...state,
                loading: false,
                classes: action.classes,
                error: null
            };
        case classConstants.FETCH_CLASSES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case classConstants.CREATE_CLASS_REQUEST:
            return {
                ...state,
                creatingClass: true,
                createError: null,
            };
        case classConstants.CREATE_CLASS_SUCCESS:
            return {
                ...state,
                creatingClass: false,
                classes: [...state.classes],
            };
        case classConstants.CREATE_CLASS_FAILURE:
            return {
                ...state,
                creatingClass: false,
                createError: action.payload,
            };

        case classConstants.UPDATE_CLASS_REQUEST:
            return {
                ...state,
                updatingClass: true,
                updateError: null,
            };
        case classConstants.UPDATE_CLASS_SUCCESS:
            return {
                ...state,
                classes: action.payload,
                updatingClass: false,
                updateError: null,
            };
        case classConstants.UPDATE_CLASS_FAILURE:
            return {
                ...state,
                updatingClass: false,
                updateError: action.payload,
            };
        case classConstants.DELETE_CLASS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case classConstants.DELETE_CLASS_SUCCESS:
            return {
                ...state,
                loading: false,
                classes: state.classes.filter(c => c.ClassID !== action.payload),
            };
        case classConstants.DELETE_CLASS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case classConstants.CLEAR_CHATHISTORY_REQUEST:
            return {
                ...state,
                updatingClass: true,
                updateError: null,
            };
        case classConstants.CLEAR_CHATHISTORY_SUCCESS:
            return {
                ...state,
                classes: state.classes.map(classItem => {
                    const updatedClass = action.data.find(submission => submission.classId === classItem.ClassID);
                    // If there's a matching classId, update its flags
                    if (updatedClass) {
                        return {
                            ...classItem,
                            ClearChatFlag: updatedClass.clearChat,
                            ClearGameFlag: updatedClass.clearGame,
                            ClearStudentFlag: updatedClass.clearStudent,
                        };
                    }
                    // Return unchanged class if no match is found
                    return classItem;
                }),
                updatingClass: false,
                updateError: null,
            };
        case classConstants.CLEAR_CHATHISTORY_FAILURE:
            return {
                ...state,
                updatingClass: false,
                updateError: action.payload,
            };
        case classConstants.ACTIVATE_CLASS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case classConstants.ACTIVATE_CLASS_SUCCESS:
            return {
                ...state,
                loading: false,
                classes: state.classes.map((classItem) =>
                    classItem.ClassID === action.classes.ClassID
                        ? { ...classItem, ClassActiveStatus: action.classes.ClassActiveStatus }
                        : classItem
                ),
            };
        case classConstants.ACTIVATE_CLASS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default classReducer;
